import { Language } from "@/api/data-contracts";

/**
 * Resolves the display language for an authenticated user from the session's profile language,
 * following the same business rule as the anonymous bootstrap (see
 * `documentation/sprachdatei-verwaltung.md`): a language without a maintained/uploaded language
 * file (`availableLanguages`, see `GET /api/i18n/languages`) is not activated — the UI falls back
 * to German instead of rendering technical keys. This covers the case where a language's text
 * stock is cleared after users already stored it as their profile language.
 *
 * German itself is never demoted (mirrors the backend `BoxHubLocaleResolver` contract), even when
 * the available-languages list is empty.
 *
 * @param availableLanguages - Languages with at least one maintained/uploaded language file
 * @param sessionLanguage - The profile language from the session, if present
 * @returns The resolved `Language`, defaulting to `Language.GERMAN`
 */
export function resolveSessionLanguage(
    availableLanguages: Language[],
    sessionLanguage: Language | null | undefined
): Language {
    if (
        sessionLanguage != null &&
        sessionLanguage !== Language.GERMAN &&
        availableLanguages.includes(sessionLanguage)
    ) {
        return sessionLanguage;
    }
    return Language.GERMAN;
}
